import view from './view';
import icon from '@plone/volto/icons/megaphone.svg';

export default {
  id: 'hp_press',
  title: 'HP Press',
  icon: icon,
  group: 'homepage',
  view: view
};
